import * as React from 'react';

export default () => {
    return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 32 32"
        >
          <path d="M1.333 32h29.334c.736 0 1.333-.597 1.333-1.333V24a2.67 2.67 0 00-2.667-2.667h-4A2.67 2.67 0 0022.667 24v5.333h-2V16A2.67 2.67 0 0018 13.333h-4A2.67 2.67 0 0011.333 16v13.333h-2V24a2.67 2.67 0 00-2.666-2.667h-4A2.67 2.67 0 000 24v6.667C0 31.403.597 32 1.333 32zm23.998-8h4.002v5.333h-4L25.33 24zM14 16H18v13.333h-4L13.999 16zm-7.332 8v5.333h-4L2.665 24h4.002z"></path>
          <path d="M26.667 16c2.206 0 4-1.794 4-4s-1.794-4-4-4c-.819 0-1.581.248-2.216.672l-4.634-3.476A4.004 4.004 0 0016 0c-2.206 0-4 1.794-4 4 0 .375.055.736.152 1.08L6.977 8.741A3.969 3.969 0 004.667 8c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4c0-.375-.056-.736-.152-1.08l5.175-3.661a3.978 3.978 0 004.526.07l4.634 3.475A4.004 4.004 0 0026.667 16zM28 12c0 .735-.598 1.333-1.333 1.333A1.335 1.335 0 0125.333 12 1.335 1.335 0 0128 12zM4.667 13.333A1.335 1.335 0 013.333 12 1.335 1.335 0 016 12c0 .735-.598 1.333-1.333 1.333zm10-9.333c0-.735.598-1.333 1.333-1.333s1.333.598 1.333 1.333S16.735 5.333 16 5.333A1.335 1.335 0 0114.667 4z"></path>
        </svg>
    );
}